import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as reservationActions } from '../../../domain/useCases/reservation/getSubscribedsTabletsUseCase';
import { Creators as statusResourceActions } from '../../../domain/useCases/reservation/getStatusResourceUseCase';
import MeanView from './ReservationView';
import useTitle from '@/presentation/hooks/useTitle';
import useExternalSettings from '../../hooks/useExternalSettings';
import XCheckpointManager from '../../../core/managers/xcheckpointManager';
import useProfile from '@/presentation/hooks/useProfile';
import constants from '../../constants';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const MeanViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { academic } = useProfile();
  const { currentPeriod } = useExternalSettings();
  const isPeriodCurrent = useSelector(
    (state: any) =>
      state.getPeriods?.data?.some((period: any) => period.isCurrent) ?? false
  );
  const studentInPeriodCurrent = () =>
    isPeriodCurrent || Number(academic?.period?.id) === Number(currentPeriod);

  const [showModalPenaltie, setShowModalPenaltie] = useState(false);
  const [showModalStatus, setShowModalStatus] = useState(false);
  const [loadResources, setLoadResources] = useState(false);

  const { data: reservedTablets, isLoading: isLoadingSubscribeds } =
    useSelector((state: any) => state.getSubscribedsTablets);

  const { data: statusResource, isLoading: isLoadingStatus } = useSelector(
    (state: any) => state.getStatusResource
  );

  useTitle('Reserva de recursos');

  useEffect(() => {
    XCheckpointManager.registerStart('Reserva recursos inscritos');
    GoogleAnalytics.writeLog('portal-services-reservation', 'services');
    dispatch(reservationActions.getSubscribedsTablets());
    dispatch(statusResourceActions.getStatusResource());
    setLoadResources(true);
  }, []);

  useEffect(() => {
    if (loadResources && !isLoadingSubscribeds && !isLoadingStatus) {
      XCheckpointManager.registerEnd('Reserva recursos inscritos');
      setLoadResources(false);
    }
  }, [isLoadingSubscribeds, isLoadingStatus]);

  const goBackButton = () => {
    history.push('/servicios');
  };

  const handleSelectResource = (id: string) => {
    history.push(`/servicios/recursos/reserva/detalle?id=${id}`);
  };

  const handleValidationResource = (path: string, type: 'T' | 'C' | 'S') => {
    if (type === 'T') {
      if (!statusResource?.tabletIsReady) {
        setShowModalStatus(true);
        return;
      }
      if (statusResource?.tabletIsPenalized) {
        setShowModalPenaltie(true);
        return;
      }
    } else {
      if (!statusResource?.computerIsReady) {
        setShowModalStatus(true);
        return;
      }
      if (statusResource?.computerIsPenalized) {
        setShowModalPenaltie(true);
        return;
      }
    }
    history.push(path);
  };

  return (
    <MeanView
      goBackButton={goBackButton}
      reservedTablets={reservedTablets?.subscribeds}
      penalizedResource={{ showModalPenaltie, setShowModalPenaltie }}
      statusResource={{ showModalStatus, setShowModalStatus }}
      handleSelectResource={handleSelectResource}
      handleValidationResource={handleValidationResource}
      isLoading={isLoadingStatus || isLoadingSubscribeds}
      studentCampus={academic.campus}
      inPeriodCurrent={studentInPeriodCurrent()}
      subsectionHeader={constants.subsectionHeader}
    />
  );
};

export default MeanViewController;
